var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"value":_vm.value,"options":_vm.datalist,"multiple":true,"label":"labelText","track-by":"labelText","maxHeight":200,"hideSelected":true,"showLabels":false,"placeholder":""},on:{"input":_vm.OninputChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }